import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories, hotArticles, latestArticles } from '@/mocks/articles';

export default function Home() {
  const [activeTab, setActiveTab] = useState<'latest' | 'hot'>('latest');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const totalPages = Math.ceil(latestArticles.length / pageSize);
  const paginatedArticles = latestArticles.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '爆料网 - 官网首页',
          description: '爆料网官网提供最新爆料资讯入口，汇聚51爆料网、91爆料网等热门平台内容。每日同步更新吃瓜爆料地址与独家内幕。',
          url: 'https://www.baoliao.com/',
        }}
      />
      <SchemaOrg type="Organization" />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[550px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20newsroom%20with%20dramatic%20red%20accent%20lighting%2C%20multiple%20digital%20screens%20displaying%20breaking%20news%2C%20abstract%20geometric%20shapes%20in%20warm%20crimson%20and%20dark%20charcoal%20background%2C%20futuristic%20media%20hub%20atmosphere%2C%20cinematic%20lighting%20with%20volumetric%20rays%2C%20professional%20broadcast%20studio%20aesthetic&width=1600&height=900&seq=hero-baoliao-main&orientation=landscape"
              alt="爆料网 - 最新爆料资讯"
              className="absolute inset-0 w-full h-full object-cover"
              title="爆料网 - 最新爆料资讯与独家内幕"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
              <div className="w-full max-w-3xl">
                <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
                  最新爆料资讯，一手掌握
                </h1>
                <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
                  汇聚51爆料网、91爆料网等全网热门爆料内容，每日同步更新最新吃瓜爆料地址与独家内幕
                </p>
                <div className="flex items-center gap-3 justify-center flex-wrap">
                  {categories.slice(0, 4).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="px-5 py-2.5 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap border border-white/30"
                    >
                      <i className={`${cat.icon} mr-1.5`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-8 relative z-10">
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-6">
              <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-2 md:gap-3">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex flex-col items-center gap-2 p-3 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer group"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-500 transition-colors">
                      <i className={`${cat.icon} text-lg md:text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
                    </div>
                    <span className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Hot Articles Banner */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 mt-10">
            <div className="flex items-center justify-between mb-5">
              <div className="flex items-center gap-2">
                <i className="ri-fire-line text-xl text-primary-500"></i>
                <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                  热门爆料
                </h2>
              </div>
              <Link
                to="/category/shehui"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {hotArticles.slice(0, 6).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          {/* Latest Articles with Tabs */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 mt-12 mb-14">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-5">
              <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
                <button
                  onClick={() => { setActiveTab('latest'); setCurrentPage(1); }}
                  className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === 'latest'
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  最新爆料
                </button>
                <button
                  onClick={() => { setActiveTab('hot'); setCurrentPage(1); }}
                  className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === 'hot'
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  热门推荐
                </button>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="px-3 py-1 text-xs rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div className="space-y-4">
              {(activeTab === 'latest' ? paginatedArticles : hotArticles).map((article) => (
                <ArticleCard key={article.id} article={article} variant="horizontal" />
              ))}
            </div>

            {activeTab === 'latest' && totalPages > 1 && (
              <div className="flex items-center justify-center gap-1 mt-8">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="w-9 h-9 flex items-center justify-center rounded-lg text-sm text-foreground-600 hover:bg-background-100 disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer transition-colors"
                >
                  <i className="ri-arrow-left-s-line"></i>
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                      currentPage === page
                        ? 'bg-primary-500 text-background-50'
                        : 'text-foreground-600 hover:bg-background-100'
                    }`}
                  >
                    {page}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="w-9 h-9 flex items-center justify-center rounded-lg text-sm text-foreground-600 hover:bg-background-100 disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer transition-colors"
                >
                  <i className="ri-arrow-right-s-line"></i>
                </button>
              </div>
            )}
          </section>

          {/* Features Section */}
          <section className="bg-background-100/70 py-14">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                  为什么选择爆料网
                </h2>
                <p className="text-foreground-600 max-w-lg mx-auto">
                  我们致力于为用户提供最快、最全、最可靠的爆料资讯服务
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  { icon: 'ri-flashlight-line', title: '实时更新', desc: '24小时不间断同步最新爆料资讯，确保您第一时间获取热点内容' },
                  { icon: 'ri-global-line', title: '全网聚合', desc: '汇聚51爆料网、91爆料网等多家平台内容，一站浏览全部爆料' },
                  { icon: 'ri-shield-check-line', title: '可靠信源', desc: '严格审核信息来源，确保每一条爆料都有据可查，拒绝虚假信息' },
                  { icon: 'ri-smartphone-line', title: '多端适配', desc: 'PC端、移动端完美适配，随时随地畅享爆料资讯阅读体验' },
                ].map((feature, index) => (
                  <div
                    key={index}
                    className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center"
                  >
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100">
                      <i className={`${feature.icon} text-xl text-primary-600`}></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">
                      {feature.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
              常见问题
            </h2>
            <SchemaOrg
              type="FAQPage"
              data={{
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: '9-11爆料网打不开怎么办？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '如果9-11爆料网打不开，可以尝试通过爆料网官网获取最新入口地址。我们实时监控各爆料平台的访问状态，确保为用户提供可用的最新网址。同时建议清除浏览器缓存或尝试使用不同的网络环境访问。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '51爆料网和91爆料网有什么区别？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '51爆料网和91爆料网都是热门的爆料资讯平台，两者内容侧重略有不同。51爆料网更偏向社会热点和深度调查类内容，91爆料网则更侧重于娱乐八卦和明星动态。爆料网整合了两者的精华内容，用户无需分别访问。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '如何获取每日最新的吃瓜爆料地址？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '访问爆料网官网首页即可获取每日最新吃瓜爆料内容。我们将实时同步更新各大爆料平台的最新资讯，您也可以将爆料网加入浏览器收藏夹，方便随时访问最新爆料内容。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '爆料网的内容是否可靠？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '爆料网致力于为用户提供可靠的资讯内容。我们的编辑团队会对每一条爆料进行核实和筛选，确保信息来源的可信度。同时我们也会注明信息来源，供用户自行判断。如发现不实信息，欢迎通过联系我们页面进行反馈。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '如何向爆料网投稿？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '您可以通过爆料网官网的"关于我们"页面找到投稿联系方式。我们欢迎用户分享真实可靠的爆料信息，您的投稿经过编辑审核后将在网站上发布。请确保投稿内容的真实性和合法性。',
                    },
                  },
                ],
              }}
            />
            <div className="max-w-2xl mx-auto space-y-3">
              {[
                { q: '9-11爆料网打不开怎么办？', a: '如果9-11爆料网打不开，可以尝试通过爆料网官网获取最新入口地址。我们实时监控各爆料平台的访问状态，确保为用户提供可用的最新网址。同时建议清除浏览器缓存或尝试使用不同的网络环境访问。' },
                { q: '51爆料网和91爆料网有什么区别？', a: '51爆料网和91爆料网都是热门的爆料资讯平台，两者内容侧重略有不同。51爆料网更偏向社会热点和深度调查类内容，91爆料网则更侧重于娱乐八卦和明星动态。爆料网整合了两者的精华内容，用户无需分别访问。' },
                { q: '如何获取每日最新的吃瓜爆料地址？', a: '访问爆料网官网首页即可获取每日最新吃瓜爆料内容。我们将实时同步更新各大爆料平台的最新资讯，您也可以将爆料网加入浏览器收藏夹，方便随时访问最新爆料内容。' },
                { q: '爆料网的内容是否可靠？', a: '爆料网致力于为用户提供可靠的资讯内容。我们的编辑团队会对每一条爆料进行核实和筛选，确保信息来源的可信度。同时我们也会注明信息来源，供用户自行判断。如发现不实信息，欢迎通过联系我们页面进行反馈。' },
                { q: '如何向爆料网投稿？', a: '您可以通过爆料网官网的"关于我们"页面找到投稿联系方式。我们欢迎用户分享真实可靠的爆料信息，您的投稿经过编辑审核后将在网站上发布。请确保投稿内容的真实性和合法性。' },
              ].map((faq, index) => (
                <details
                  key={index}
                  className="group border border-background-200/70 rounded-lg overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-4 cursor-pointer hover:bg-background-100/70 transition-colors list-none">
                    <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}